"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Offer", {
  enumerable: true,
  get: function get() {
    return _Offer.Offer;
  }
});
var _Offer = require("./Offer");